import http from './index'

const prefix = '/api/account/pc'

export const getWechatAuthorizeUrl = () => {
  return http.get({
    url: '/api/account/qr-connect/authorize'
  })
}

/**
 * 获取微信登录 SID (预留接口)
 */
export const getWxLoginSid = () => {
  return http.get({
    url: '/api/wx/sid'
  })
}

/**
 * 获取微信登录状态 (预留接口)
 * @param {string} sid
 */
export const getWxLoginStatus = (sid) => {
  return http.get({
    url: '/api/wx/status',
    params: { sid }
  })
}

// 退出登录
export const logout = () => {
  return http.post({
    url: prefix + '/clear',
  })
}

// 修改密码
export const changePwd = data => {
  return http.post({
    url: prefix + '/changePwd',
    data
  })
}

// 忘记密码
export const forgetPwd = data => {
  return http.post({
    url: prefix + '/forgetPwd',
    data
  })
}

// 获取用户信息
export const getUserInfo = () => {
  return http.get({
    url: prefix + '/info',
  })
}

// 登录
export const login = data => {
  return http.post({
    url: prefix + '/authorize',
    data
  })
}

// 注册
export const register = data => {
  return http.post({
    url: prefix + '/register',
    data
  })
}

// 发送验证码
export const sendCode = data => {
  return http.post({
    url: prefix + '/sendCode',
    data
  })
}

// 编辑用户信息（不包括密码）
export const updateCustomerInfo = data => {
  return http.post({
    url: prefix + '/updateCustomerInfo',
    data
  })
}
